import has from 'lodash/has';
import get from 'lodash/get';

import { StoreInfoService } from 'services/storeInfo.service';

export const GaService = angular
    .module('checkout.services.gaService', [
        StoreInfoService
    ]).service('gaService', (storeInfoService, $window, $q) => {
        $window.dataLayer = $window.dataLayer || [];
        const tracked = { 1: false, 2: false, 3: false, 4: false, 5: false };
        function setTracked(stepNumber, isTracked) {
            tracked[stepNumber] = isTracked;
        }

        function getTracked(stepNumber) {
            return tracked[stepNumber];
        }

        function extractProductsFromCart({ items }) {
            let promises = items.map(item => createProductPayload(item));
            return $q.all(promises);
        }

        function createProductPayload(item) {
            const { product, quantity } = item;
            return storeInfoService.get().then((storeInfo) => {
                const storeUrl = storeInfo.customDomain && storeInfo.customDomain !== '' ?
                    storeInfo.customDomain : storeInfo.storeUrl;
                const payload = {
                    dimension2: storeInfo.tenant,
                    dimension3: storeInfo.name,
                    dimension4: storeUrl
                };

                if (product) { // old cart shape
                    Object.assign(payload, {
                        id: product.sku || product.id,
                        name: product.name,
                        price: product.price
                    });
                    if (get(product, 'availability.preOrder.enabled')) payload.dimension6 = 'pre-order';
                } else { // new cart shape
                    Object.assign(payload, {
                        id: item.sku || item.productId,
                        name: item.productName,
                        price: item.price.amount / 100
                    });
                    if (get(item, 'preOrderAvailable')) payload.dimension6 = 'pre-order';
                }


                if (isFinite(quantity)) {
                    payload.quantity = quantity;
                }

                if (has(product, 'images[0].imageLink.fullUri')) {
                    payload.dimension5 = product.images[0].imageLink.fullUri;
                } else if (has(product, 'imageMetadata.imageLink.fullUri')) {
                    payload.dimension5 = product.imageMetadata.imageLink.fullUri;
                } else if (item.imageSrc) {
                    payload.dimension5 = item.imageSrc;
                }

                return payload;
            });
        }

        function logCheckoutStep(stepNumber, optionValue, cart) {
            if (getTracked(stepNumber)) return;
            extractProductsFromCart(cart).then((extractedProducts) => {
                $window.dataLayer.push({
                    event: 'checkout',
                    ecommerce: {
                        checkout: {
                            actionField: { step: stepNumber, option: optionValue },
                            products: extractedProducts
                        }
                    }
                });
            });
            setTracked(stepNumber, true);
        }

        function logPurchase({ orderNumber, grandTotal, taxAmount, cart }) {
            const shippingCost = cart.shippingMethod && cart.shippingMethod.shippingCost ?
                cart.shippingMethod.shippingCost : 0;
            const couponCode = cart.discount && cart.discount.code ? cart.discount.code : '';

            extractProductsFromCart(cart).then((extractedProducts) => {
                storeInfoService.get().then((storeInfo) => {
                    $window.dataLayer.push({
                        event: 'productPurchase',
                        adwords_conversion_id: get(storeInfo, 'thirdPartyIntegrations.adwordsConversionId', null),
                        adwords_conversion_label: get(storeInfo, 'thirdPartyIntegrations.adwordsConversionLabel', null),
                        ecommerce: {
                            purchase: {
                                actionField: {
                                    id: orderNumber,
                                    affiliation: storeInfo.tenant,
                                    revenue: grandTotal,
                                    tax: taxAmount,
                                    shipping: shippingCost,
                                    coupon: couponCode
                                },
                                products: extractedProducts
                            }
                        }
                    });
                });
            });
        }

        function sendAppLoadedEvent(googleAnalyticsId) {
            $window.dataLayer.push({
                event: 'initialAppLoaded',
                U_GA_ID: googleAnalyticsId
            });
        }

        function sendOrderPlacementErrorEvent(errorResponse) {
            const eventLabel = get(errorResponse, 'data.items[0].message', 'Order Placement Error');
            const address = get(errorResponse, 'config.data.deliverTo.address', {});
            const doesAddressLine1StartWithoutANumber = address.country === 'US' && /^[^0-9]/.test(address.address1);
            $window.dataLayer.push({
                event: 'orderError',
                eventCategory: 'Errors',
                eventAction: 'place order',
                eventLabel,
                // Sending the eventValue as 1 if the address line 1 doesn't start with a number.
                // This will help us find out how many Order placement failures are due to the
                // address missing the street number.
                eventValue: doesAddressLine1StartWithoutANumber ? 1 : 0
            });
        }

        function sendVirtualPageViewEvent(path, title, tenantId) {
            $window.dataLayer.push({
                event: 'virtualPageView',
                virtualPage: path,
                virtualTitle: title,
                tenantID: tenantId
            });
        }

        return {
            logCheckoutStep,
            logPurchase,
            sendAppLoadedEvent,
            sendVirtualPageViewEvent,
            sendOrderPlacementErrorEvent
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/ga.service.js